module.exports = __webpack_public_path__ + "media/control-tower-logo.e69bda1a71a65f78fc228aedf9c24ee8.svg";